import React from 'react';

import {contactListColumnIds, groupRiskAssessmentPropName} from '../../../../../util/uiconstants';

import DashboardCheck from '../../DashboardCheck';

const GroupRiskAssessmentColumn = ({item}) => <DashboardCheck condition={item.groupRiskAssessment.hasAccess} />;

export const config = (labels) => ({
	id: contactListColumnIds.groupRiskAssessment,
	label: labels.columnGroupRiskAssessment,
	propName: groupRiskAssessmentPropName,
	width: 'var(--px-200)',
	sortBy: [{propName: 'groupRiskAssessment', sortByField: 'hasAccess'}, 'name', 'lastName'],
	customCell: (item) => {
		const props = {item};
		return <GroupRiskAssessmentColumn {...props} />;
	}
});
